export enum Routes {
  HOME = '/',
  CONTACT = '/contact',
  PROJECTS = '/projects',
  DETAILS_PROJECTS = '/projects/:projectId',
}
